import { render, staticRenderFns } from "./SecondSellerReceiving.vue?vue&type=template&id=154c630e&"
import script from "./SecondSellerReceiving.vue?vue&type=script&lang=js&"
export * from "./SecondSellerReceiving.vue?vue&type=script&lang=js&"
import style0 from "./SecondSellerReceiving.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports